import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PasswordReset.css";

const PasswordResetPage = () => {
  const [email, setEmail] = useState("");  
  const navigate = useNavigate(); 
  
  const temp_id = "673f72c124daa756e66378d9";
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const RequestPasswordResetOtp = async () => {
    try {
      const response = await fetch(`https://admin.riymay.com/api/v1/admin/password-reset?email=${email}`);
      if (response.ok) {
        alert("OTP sent to your email!");
        navigate('/password-change', {state:{email: email}});
      } else {
        const errorData = await response.json();
        alert(`Error: ${"unable to send email Please try again later." || 'Something went wrong'}`);
      }
    } catch (error) {
      console.error("Error during OTP request:", error);
      alert("unable to send email. Please try again later.");
    }
  };

  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <h2>Reset Your Password</h2>
        <p>Please enter your email to receive an OTP for resetting your password.</p>
        <div className="form-group">
          <label htmlFor="user-email">Email Address</label>
          <input
            id="user-email"
            type="email"
            className="email-input"
            value={email}
            onChange={handleEmailChange}
            placeholder="Enter your email"
            required
          />
        </div>
        <button className="submit-button" onClick={RequestPasswordResetOtp}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default PasswordResetPage;
